import { useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import RequestServies from "../../../services/RequestServies";
import Swal from "sweetalert2"; // Import SweetAlert2

const UsedItemReport = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [status, setStatus] = useState("all");
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalcount, setTotalCount] = useState(0)

  // ✅ Date range validation (max 31 days)
  const isDateRangeValid = (from, to) => {
    const start = new Date(from);
    const end = new Date(to);

    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    const diffTime = end - start;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays <= 30; // ✅ allows 31 days
  };

  const fetchReport = async () => {
    if (!fromDate || !toDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Dates",
        text: "Please select both From and To dates.",
      });
      return;
    }

    // ✅ NEW VALIDATION (ONLY FOR GENERATE)
    if (!isDateRangeValid(fromDate, toDate)) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Range",
        text: "You can generate report for maximum 31 days only.",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await RequestServies.reportUsedItems({
        fromDate,
        toDate,
        status,
      });

      setReportData(response.data);
      setTotalCount(response.count);

      Swal.fire({
        icon: "success",
        title: "Report Generated",
        text: `Report Successfully Generated for the Selected Date Range.`,
      });
    } catch (error) {
      console.error("Error fetching report data:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch report data. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  const filteredData = reportData.filter((item) => {
    // Split search by space or comma and clean up
    const queries = searchQuery
      .toLowerCase()
      .split(/[\s,]+/)
      .filter(q => q.trim() !== "");

    // Each query must match at least one of the fields
    return queries.every(query =>
      String(item?.inventory?.store?.name || "").toLowerCase().includes(query) ||
      String(item?.requisitionNo?.requisitionNo || "").toLowerCase().includes(query) ||
      String(item?.inventory?.masterItem?.partNo || "").toLowerCase().includes(query) ||
      String(item?.inventory?.masterItem?.description || "").toLowerCase().includes(query)
    );
  });
  // ✅ Total of receivedQty from filtered results
  const totalUsedQty = filteredData.reduce((sum, item) => {
    return sum + (Number(item?.usedQty) || 0);
  }, 0);


  const downloadExcel = async () => {
    if (!fromDate || !toDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Dates",
        text: "Please select both From and To dates.",
      });
      return;
    }

    try {
      Swal.fire({
        title: "Preparing Report...",
        text: "Downloading full data...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const response = await RequestServies.downloadMIVReport({
        fromDate,
        toDate,
        status,
      });

      // ✅ create file from blob
      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      // ✅ dynamic file name
      const fileName = `MIV_Report_${new Date().toISOString().split("T")[0]}.xlsx`;
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      link.remove();

      Swal.fire("Success", "Report Downloaded", "success");

    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Download failed", "error");
    }
  };
  return (
    <>
      <div className="col-xl-12">
        <div className="filter cm-content-box box-primary">
          <div className={`content-title`}>
            <div className="cpa">
              <i className="fas fa-filter me-2"></i>Filter
            </div>
            <div className="tools">
              <Link
                to={"#"}
                className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                onClick={() => setOpen(!open)}
              >
                <i className="fas fa-angle-up"></i>
              </Link>
            </div>
          </div>
          <Collapse in={open}>
            <div className="cm-content-body form excerpt">
              <div className="card-body">
                <div className="row">
                  <div className="col-xl-3 col-xxl-3">
                    <label className="ms-2">From</label>
                    <input
                      type="date"
                      name="fromDate"
                      className="form-control mb-xxl-0 mb-3"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>

                  <div className="col-xl-3 col-xxl-3">
                    <label className="ms-2">To</label>
                    <input
                      type="date"
                      name="toDate"
                      className="form-control mb-xxl-0 mb-3"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>
                  <div className="col-xl-3 col-xxl-3">
                    <label className="ms-2">Status</label>
                    <select
                      className="form-select"
                      value={status}
                      style={{ height: '55px' }}
                      onChange={(e) => setStatus(e.target.value)}
                    >

                      <option value="all">All</option>
                      <option value="approved">Completed</option>
                      <option value="pending">Approval Pending</option>
                      <option value='rejected'>Rejected</option>
                      <option value='open'>Open</option>
                    </select>
                  </div>
                  <div className="col-xl-3 col-xxl-3">
                    <label className="ms-2">Action</label>

                    <div className="d-flex gap-2">
                      <button
                        className="form-control btn btn-primary"
                        onClick={fetchReport}
                        disabled={loading}
                      >
                        {loading ? "Loading..." : "Generate"}
                      </button>

                      <button
                        className="btn btn-success w-100"
                        onClick={downloadExcel}
                        disabled={!fromDate || !toDate}
                      >
                        Download
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </Collapse>
        </div>

        <div className="filter cm-content-box box-primary">
          <div className={`content-title`}>
            <div className="cpa">
              <i className="fa fa-list me-2" aria-hidden="true"></i>Material Issue
              Report <span className="badge bg-orange ms-2">{totalcount}</span>
            </div>
            <div className="tools">
              <Link
                to={"#"}
                className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                onClick={() => setOpen2(!open2)}
              >
                <i className="fas fa-angle-up"></i>
              </Link>
            </div>
          </div>
          <Collapse in={open2}>
            <div className="cm-content-body form excerpt">
              <div className="card-body">
                {!loading && reportData?.length > 0 && (
                  <div className="row mb-2">
                    <div className="col-12">
                      <div className="d-flex justify-content-center align-items-center">
                        <input
                          className="form-control"
                          style={{ width: "500px" }}
                          id="searchInput"
                          placeholder="Store, MIV No, Part No or Description"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                )}

                <div className="scrolltable">
                  <table className="table table-bordered table-striped">
                    <thead
                      className="sticky-table-header"
                    >
                      <tr>
                        <th>S.No</th>
                        <th>Store</th>
                        <th>Date</th>
                        <th>MIV No</th>
                        <th>Part No</th>
                        <th>Description</th>
                        <th>Unit</th>
                        <th>Auth</th>
                        <th>Required Qty</th>
                        <th>C-Stock</th>
                        <th>Approved Qty</th>
                        <th>Status</th>
                        <th>Updated Date</th>
                        <th>Admin Reason</th>
                        <th>MIV Image</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.length > 0 ? (
                        <>
                          {filteredData.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td className="scrollable-description">{item?.inventory?.store?.name}</td>
                              <td>{item?.createdAt ? item.createdAt.split("T")[0] : ""}</td>
                              <td>{item?.miv?.mivNo}</td>
                              <td>{item?.inventory?.masterItem?.partNo}</td>
                              <td className="scrollable-description">{item?.inventory?.masterItem?.description}</td>
                              <td>{item?.inventory?.masterItem?.unit?.name}</td>
                              <td>{item?.inventory?.qtyAuth}</td>
                              <td>{item?.usedQty}</td>
                              <td>{item?.inventory?.currentStock != null ? item.inventory.currentStock.toFixed(2) : "0.00"}</td>
                              <td>{item?.approveQty}</td>
                              <td>{item?.status}</td>
                              <td>{item?.updatedAt ? item.updatedAt.split("T")[0] : ""}</td>
                              <td>{item?.status === "pending" ? "Approval Pending" : "Completed"}</td>
                              <td>
                                {item?.miv?.image ? (
                                  <span
                                    style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                    onClick={() =>
                                      window.open(`https://indigoinfra.in/img/miv/${item?.miv?.image}`, "_blank")
                                    }
                                  >
                                    View Image-{item?.miv?.mivNo}
                                  </span>
                                ) : (
                                  "No image available"
                                )}
                              </td>
                            </tr>
                          ))}

                          {/* ✅ Total Row */}
                          <tr>
                            <td colSpan="11" className="text-end"><strong>Total Used Qty:</strong></td>
                            <td colSpan="5"><strong>{totalUsedQty}</strong></td>
                          </tr>
                        </>
                      ) : (
                        <tr>
                          <td colSpan="16" className="text-center">No data available.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>


              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </>
  );
};

export default UsedItemReport;
